export default __webpack_public_path__ + "static/media/fail.7c6a020b.svg";